import HTMLElement from '../html-element/HTMLElement.js';
/**
 * HTMLParagraphElement
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLParagraphElement
 */
export default class HTMLParagraphElement extends HTMLElement {}
